import React from "react";
import Text from "@/components/ui/text";
import SingleCheckbox from "@/components/ui/SingleCheckbox";
import TextEditor from "@/components/controls/TextEditor/TextEditor";
import { CheckboxWithTextControlValue, ControlProps } from "../types";

export const CheckboxWithTextControl: React.FC<ControlProps> = ({
  config,
  value,
  onChange,
  name,
  checkboxLabel
}) => {
  const current =
    value && typeof value === "object" && "checked" in value
      ? (value as CheckboxWithTextControlValue)
      : { checked: false, text: "" };

  return (
    <div className="flex flex-col gap-2">
      <SingleCheckbox
        id={name}
        isChecked={current.checked}
        onCheckedChange={(checked) =>
          onChange({
            checked: checked === true,
            text: checked === true ? current.text : ""
          })
        }
        label={checkboxLabel ?? ""}
      />
      {current.checked ? (
        <div className="pl-7 flex flex-col gap-1">
          {config?.textAreaQuestion ? (
            <Text>{config.textAreaQuestion}</Text>
          ) : null}
          <TextEditor
            value={current.text}
            onBlur={(text: string) => onChange({ checked: true, text })}
            variant="form"
          />
        </div>
      ) : null}
    </div>
  );
};
